// extracted by mini-css-extract-plugin
module.exports = {"container":"TrashButton_container__1Nulg","trashIcon":"TrashButton_trashIcon__1a8y9","disabled":"TrashButton_disabled__1vfdM"};